import type { BranchDto } from 'korint-sdk';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { formatZonedDateTime } from '../../lib/date-formatting';
import { RecapLine } from './StopRequestSummary';
import { useTimeZone } from '@folio/utils/time-zone';
import { Text } from '@folio/components/ui/text';

export function StopCancellationSummary({
  branch: { closeComment, closedAt, closeReason },
}: {
  branch: Pick<BranchDto, 'closeComment' | 'closedAt' | 'closeReason'>;
}) {
  const { t } = useTranslation();
  const timeZone = useTimeZone();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('stopFunnel.cancellation.title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <RecapLine
          label={t('stopFunnel.cancellation.cancelledAt')}
          value={closedAt ? formatZonedDateTime(new Date(closedAt), timeZone) : undefined}
        />
        <RecapLine
          label={t('stopFunnel.cancellation.cancelledBy')}
          value={
            closeReason
              ? t(`stopFunnel.cancellation.by.${closeReason}`, { defaultValue: '' })
              : undefined
          }
        />
        <div className="py-2">
          <Text inline size="sm" tone="muted">
            {t('stopFunnel.cancellation.comment')}
          </Text>
          <Text size="sm" className="whitespace-pre-wrap">
            {closeComment}
          </Text>
        </div>
      </CardContent>
    </Card>
  );
}
